module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "calculator",
    class: {
      print: _vm.printing
    }
  }, [(!_vm.printing) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.companies.length > 0 && !_vm.printing) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "contain-rows"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Bensin\n            "), _c('div', {
    staticClass: "radio-toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "id": "gas",
      "type": "radio",
      "name": "type",
      "value": "gasPrice"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "gasPrice")
    },
    on: {
      "change": function($event) {
        _vm.type = "gasPrice"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gas"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Diesel\n            "), _c('div', {
    staticClass: "radio-toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "id": "diesel",
      "type": "radio",
      "name": "type",
      "value": "dieselPrice"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "dieselPrice")
    },
    on: {
      "change": function($event) {
        _vm.type = "dieselPrice"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "diesel"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mobile-only mobile-header"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_vm._v("\n          Välj ett bolag för jämförelse\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "column-wrap"
  }, [_c('div', {
    staticClass: "columns checkbox-toolbar"
  }, _vm._l((_vm.companies), function(company) {
    return (company.name !== 'Tanka') ? _c('div', {
      key: company.name,
      staticClass: "column"
    }, [_c('div', {
      staticClass: "image-container"
    }, [(company.name !== 'Other') ? [_c('a', {
      staticClass: "letter-spacing",
      attrs: {
        "href": company.website,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])] : [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })]], 2), _vm._v(" "), _c('div', {
      staticClass: "checkbox",
      class: [_vm.chosenCompanies.includes(company.name) ? 'checked' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.fixateOnlyThisTarget(company.name)
        },
        "touchstart": function($event) {
          $event.preventDefault();
          _vm.fixateOnlyThisTarget(company.name)
        }
      }
    })]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container checkbox-toolbar",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "added-margin-top no-mobile"
    }, [_c('div', {
      staticClass: "checkbox",
      class: [_vm.chosenCompanies.includes(company.name) ? 'checked' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.fixateTarget(company.name)
        },
        "touchstart": function($event) {
          $event.preventDefault();
          _vm.fixateTarget(company.name)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-container"
    }, [(company.name !== 'Other') ? [_c('a', {
      staticClass: "letter-spacing",
      attrs: {
        "href": company.website,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])] : [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })]], 2)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_c('transition', [(_vm.showListPris) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n              Listpris är ett förutbestämt pris som gäller för företagskunder. Alla ev. rabatter dras från listpriset.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container question",
    on: {
      "click": function($event) {
        _vm.showListPris = !_vm.showListPris
      },
      "mouseover": function($event) {
        _vm.showListPris = true
      },
      "mouseleave": function($event) {
        _vm.showListPris = false
      }
    }
  }, [_vm._v("\n            Listpris kr/liter\n            "), _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "question-circle"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "input-replacement"
    }, [_vm._v("\n              " + _vm._s(_vm._f("normalize")(company.data[_vm.type + 'List'])) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "number",
        "step": "0.01"
      },
      domProps: {
        "value": _vm.convertPrice(company.data[_vm.type])
      },
      on: {
        "change": function($event) {
          _vm.$emit('updatePrice', $event, company.name, _vm.type)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm.convertDiscount(company.data.cardDiscount)
      },
      on: {
        "keyup": function($event) {
          _vm.$emit('updateDiscount', $event.target.value, 'cardDiscount', company.name)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm.convertDiscount(company.data.invoiceDiscount)
      },
      on: {
        "keyup": function($event) {
          _vm.$emit('updateDiscount', $event.target.value, 'invoiceDiscount', company.name)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "input-replacement"
    }, [_vm._v("\n              " + _vm._s(_vm.calculatedDiscounts(company.name)) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row spacing"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "result-column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.calculateTotal(company.name))) + "\n          ")])])
  })], 2), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Resultat av jämförelse")])]) : _vm._e()])]) : _c('div', {
    staticClass: "wrap print"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chosenType"
  }, [_vm._v("Vald drivmedelstyp:")]), _vm._v(" "), (_vm.type === 'dieselPrice') ? [_vm._v("\n        Diesel\n      ")] : [_vm._v("\n        Bensin\n      ")]], 2), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("\n          Valda aktörer för jämförelse\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('th', {
      key: company.name
    }, [_c('div', {
      class: {
        greyBack: company.name === 'Other'
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Listpris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(company.data[_vm.type + 'List'])) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Skyltat pris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(company.data[_vm.type])) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Kortrabatt öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.convertDiscount(company.data.cardDiscount)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Fakturarabatt öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.convertDiscount(company.data.invoiceDiscount)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Besparing öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.calculatedDiscounts(company.name)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Slutpris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(_vm.calculateTotal(company.name))) + " 5\n        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.printing) ? _c('img', {
    staticClass: "desktop",
    attrs: {
      "src": require("assets/images/screen_desktop.png")
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('h1', [_vm._v("Jämför drivmedelspriser")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Drivmedelstyp\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container no-mobile"
  }, [_vm._v("\n            Välj två eller fler för att jämföra\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Skyltat pris kr/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Kortrabatt öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Fakturarabatt öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Besparing öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container endprice-modifier"
  }, [_vm._v("\n            Slutpris/liter\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d067594","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/calculator.vue
// module id = 283
// module chunks = 1